import React from "react";
import {optional, parseBoolean, uuid} from "../../utils/lang";
import _ from "underscore";
import { isNotEmpty } from "../../framework/utils";


export class MaterialIcon extends React.Component {
    constructor(props) {
        super(props)
    }

    onClick(e) {
        if (_.isFunction(this.props.onClick))
            this.props.onClick(e);
    }

    render() {
        const style = optional(this.props.style, {}),
            icon = this.props.icon,
            twoTone = parseBoolean(optional(this.props.twoTone, false)),
            rounded = parseBoolean(optional(this.props.rounded, true)),
            hasOnClick = this.props.onClick && _.isFunction(this.props.onClick);

        let className = "material-icons";
        if (rounded) {
            className += "-round";
        } else if (twoTone) {
            className += "-two-tone";
        }
        if (isNotEmpty(this.props.className)) {
            className += " " + this.props.className;
        }

        if (hasOnClick) {
            className += " pointer-cursor";
        }
        
        return (
            <i
                onClick={this.onClick.bind(this)}
                style={style}
                className={className}
            >
                {icon}
            </i>
        )
    }
}

export class MaterialIconWithTooltip extends React.Component {
    constructor(props) {
        super(props);
        this.id = this.getId();
    }

    componentDidMount() {
        $('#' + this.id).tooltip({
            trigger: "hover",
            selector: "i[rel=tooltip]",
            html: true,
            template: '<div class="tooltip production-block-tooltip"><div class="title">Test</div><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        })
    }

    getId() {
        return optional(this.props.id, uuid());
    }

    render() {
        const {id, title} = this.props;

        return (
            <div
                id={id}
                data-placement="bottom"
                data-toggle="tooltip"
                title={title}
            >
                <MaterialIcon {...this.props}/>
            </div>
        )
    }
}